import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/app.css'

const app = createApp(App)

app.use(store).use(router)

// Mount the app and emit event for prerender-spa-plugin
router.isReady().then(() => {
    app.mount('#app')
    // Dispatch event to signal prerender-spa-plugin that rendering is complete
    document.dispatchEvent(new Event('render-event'))
})
